<template>
    <div class="role-manage-edit">
        <el-page-header @back="goBack" content="角色新增"></el-page-header>
        <div class="search-bar">
            <span>角色名称：</span>
            <el-input v-model="roleName"></el-input>
        </div>
        <div class="search-bar">
            <el-tree
                    :data="action_code"
                    show-checkbox
                    ref="tree"
                    node-key="id"
                    :auto-expand-parent="true"
                    :default-expand-all="true"
                    :props="defaultProps">
            </el-tree>
        </div>

        <div class="edit-page-footer">
            <el-button @click="goBack">取消</el-button>
            <el-button type="success" @click="save">保存</el-button>
        </div>
    </div>
</template>
<script>
    import Box from "@/components/Box.vue";
    import {check} from "@/utils/checkData";

    export default {
        components: {
            Box
        },
        data() {
            return {
                roleName: "",
                action_code: [],
                defaultProps: {
                    children: 'children',
                    label: 'action_name'
                },
                is_submit: false,
            };
        },
        mounted() {
            let params = {
                servername: 'Ruyi_AdminSystemServices',
                method: 'roleAllAction',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.action_code = res.data.data;
            });
        },
        computed: {},
        methods: {
            goBack() {
                window.history.go(-1);
            },
            save() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (this.roleName == '') {
                    this.$message({
                        type: "error",
                        message: '角色名称不能为空'
                    });
                    this.is_submit = false;
                    return false;
                }
                if (this.roleName.length > 30) {
                    this.$message({
                        type: "error",
                        message: '角色名称长度大于30'
                    });
                    this.is_submit = false;
                    return false;
                }

                // 获取选中的权限
                var allActionCode = this.$refs.tree.getCheckedKeys();
                if (allActionCode.length <= 0) {
                    this.$message({
                        type: "error",
                        message: '请选择权限！'
                    });
                    this.is_submit = false;
                    return false;
                }
                var actionCode = allActionCode.join(',');

                var params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'addRole',
                    params: {
                        name: this.roleName,
                        ids: actionCode,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    let _that = this
                    this.$message({
                        type: "success",
                        message: '添加成功',
                        duration: 1500,
                        onClose: function () {
                            _that.is_submit = false;
                            window.history.go(-1);
                        }
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }
        }
    };
</script>
